export const pointVert = () => `
  uniform float scale;
  attribute vec4 color;
  varying vec4 vColor;
  attribute float outline;
  varying float vOutline;
  attribute float aboveDomain;
  varying float vAboveDomain;

  void main() {
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    vColor = color;
    vOutline = outline;
    vAboveDomain = aboveDomain;
    gl_Position = projectionMatrix * mvPosition;
    gl_PointSize = scale;
  }
`

export const pointFrag = () => `
  varying vec4 vColor;
  varying float vOutline;
  varying float vAboveDomain;
  uniform sampler2D circle;
  uniform sampler2D triangle;

  void main() {
    float distance = mix(
      1.0 - texture2D(circle, gl_PointCoord).r,
      1.0 - texture2D(triangle, vec2(1.0) - gl_PointCoord).r,
      vAboveDomain
    );

    float inside = smoothstep(0.35, 0.25, distance);
    float outline = smoothstep(0.6, 0.5, distance) * vOutline;

    gl_FragColor = mix(
      mix(
        vec4(1.0, 1.0, 1.0, 0.0),
        vec4(1.0),
        outline
      ),
      vec4(vColor.rgb, vColor.a),
      inside
    );
  }
`
